import React from "react";
import { useTranslation } from "react-i18next";

import css from "./LanguageSelectComponent.module.css";
import { languages } from "../../constants";
import { getConfig } from "../../config";

const LanguageSelectComponent = () => {
  const { i18n } = useTranslation();

  const handleChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem("i18nextLng", selectedLanguage);
  };

  // Filter languages based on REACT_APP_CITY_CODE
  const filteredLanguages = languages.filter((language) => {
    const cityCode = getConfig().cityCode;

    if (cityCode === "UAE") {
      // Show Arabic instead of Georgian for UAE
      return language.code !== "ge";
    } else {
      // Show Georgian instead of Arabic for other regions
      return language.code !== "ar";
    }
  });

  return (
    <section className={css.wrap}>
      <select
        onChange={handleChange}
        className={css.selectLanguage}
        value={localStorage.getItem("i18nextLng") || "en"}
      >
        {filteredLanguages.map((language) => (
          <option key={language.code} value={language.code}>
            {language.flag}
            {language.name}
          </option>
        ))}
      </select>
    </section>
  );
};

export { LanguageSelectComponent };
